import { UtilsService } from '@/shared/utils/utils.service';
import { Injectable } from '@nestjs/common';
import { ConfigService } from '@nestjs/config';
import {
  MulterModuleOptions,
  MulterOptionsFactory,
} from '@nestjs/platform-express';
import { diskStorage, memoryStorage } from 'multer';
import { join } from 'path';

@Injectable()
export class MulterConfigService implements MulterOptionsFactory {
  constructor(
    private readonly configService: ConfigService<Record<string, any>, true>,
    private readonly utilsService: UtilsService,
  ) {}

  createMulterOptions(): MulterModuleOptions {
    const storageMode = this.configService.get<string>('config.storage.mode');

    if (storageMode !== 'local') {
      return {
        storage: memoryStorage(),
      };
    }

    const storageDir = this.configService.get<string>('config.storage.dir');
    const storagePath = join(process.cwd(), storageDir);

    return {
      // dest: storagePath,
      storage: diskStorage({
        destination: storagePath,
        // destination: (req, file, cb) => {
        //   cb(null, storagePath);
        // },
        filename: (req, file, cb) => {
          cb(null, this.utilsService.createFileName(file));
        },
      }),
    };
  }
}
